var map = {
	"./bmp.svg": 2952,
	"./doc.svg": 2953,
	"./docx.svg": 2954,
	"./file.svg": 746,
	"./jpeg.svg": 2955,
	"./jpg.svg": 2956,
	"./pdf.svg": 2957,
	"./png.svg": 2958,
	"./ppt.svg": 2959,
	"./pptx.svg": 2960,
	"./rar.svg": 2961,
	"./xls.svg": 2962,
	"./xlsx.svg": 2963,
	"./zip.svg": 2964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 975;